import React from "react";
import logo from "../styles/logo.png"; // Adjust the path to your logo image

const HeaderComponent = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      {/* Logo */}
      <img 
        src={logo} 
        alt="Logo" 
        style={{ width: "150px", marginBottom: "20px" }} 
      />
      
      {/* Titles */}
      <h2>
        مؤسسة الشهداء
      </h2>
      <h2>
        استمارة جمع بيانات شهداء ومصابين العمليات الحربية والاخطاء العسكرية والعمليات الارهابية
      </h2>
      {/* <h2 style={{ color: "red" }}>
       تصميم نهائي (تحت التجربة)
      </h2> */}
    </div>
  );
};

export default HeaderComponent;